import {
  OrientationPropertyConverter,
  orientationTypes
} from "./chunk.3SPOW6JF.js";
import {
  stepper_styles_default
} from "./chunk.ASD5S26O.js";
import {
  i as i2
} from "./chunk.LP7FQRAP.js";
import {
  getResponsiveValue
} from "./chunk.JI3RRLCG.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/stepper/stepper.ts
import { t as t2 } from "i18next";
var animationTimeout;
var FadvStepper = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlots = new HasSlotController(this, "panel");
    this.selectedStep = 0;
    this.linear = true;
    this.orientation = "horizontal";
    this.labelMode = "label";
    this.mode = "stepper";
    this.visible = false;
    this.hasScrollControls = false;
  }
  get steps() {
    var _a;
    const slot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("slot");
    return slot == null ? void 0 : slot.assignedElements().filter((e2) => hasTag(e2, "fadv-step"));
  }
  get panels() {
    var _a;
    const slot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector('slot[name="panel"]');
    return slot == null ? void 0 : slot.assignedElements().filter((e2) => hasTag(e2, "fadv-step-panel"));
  }
  async connectedCallback() {
    super.connectedCallback();
    this.handleResize = this.handleResize.bind(this);
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(document.body);
    await this.updateComplete;
    this.handleResize();
  }
  disconnectedCallback() {
    this.resizeObserver.disconnect();
    super.disconnectedCallback();
  }
  handleSelectedStepChange(oldValue, newValue) {
    var _a;
    const steps = this.steps;
    if (newValue < 0)
      return;
    if (newValue > ((_a = this.steps) == null ? void 0 : _a.length) - 1)
      return;
    if (!(steps == null ? void 0 : steps.length))
      return;
    if (oldValue === null || oldValue === void 0 || newValue === oldValue || !this.visible) {
      this.activateStep(steps, newValue);
      return;
    }
    this.animateToStep(steps, oldValue, newValue);
  }
  activateStep(steps, stepIndex) {
    if (animationTimeout) {
      clearTimeout(animationTimeout);
      animationTimeout = void 0;
    }
    for (let i3 = 0; i3 < stepIndex; i3++) {
      steps[i3].deactivate(stepIndex);
    }
    const step = steps[stepIndex];
    this.scrollToStep(step, "auto");
    step.activate(stepIndex);
  }
  animateToStep(steps, oldValue, newValue) {
    let lastStep = steps[oldValue];
    let stepIndex = newValue > oldValue ? oldValue + 1 : oldValue - 1;
    const update = () => {
      lastStep.deactivate(stepIndex);
      if (lastStep.index === oldValue) {
        emit(this, "stepper-step-deactivate");
      }
      const step = steps[stepIndex];
      this.scrollToStep(step);
      step.activate(lastStep.index);
      if (step.index === newValue) {
        animationTimeout = void 0;
        emit(this, "stepper-step-activated", { detail: { index: step.index } });
      } else {
        lastStep = step;
        stepIndex = newValue > oldValue ? stepIndex + 1 : stepIndex - 1;
        animationTimeout = setTimeout(() => update(), 150);
      }
    };
    update();
  }
  scrollToStep(step, behavior = "smooth") {
    if (!this.hasScrollControls)
      return;
    const right = step.offsetLeft + step.clientWidth;
    const scrollLeft = this.stepContainer.scrollLeft;
    const scrollRight = scrollLeft + this.stepContainer.clientWidth;
    const scrollToRight = right > scrollRight;
    const scrollToLeft = this.stepContainer.scrollLeft > step.offsetLeft;
    if (scrollToRight) {
      this.stepContainer.scroll({ left: right - this.stepContainer.clientWidth + 20, behavior });
    }
    if (scrollToLeft) {
      this.stepContainer.scroll({ left: step.offsetLeft - 20, behavior });
    }
  }
  syncSteps() {
    const orientation = getResponsiveValue(this.orientation, orientationTypes, "horizontal");
    const steps = this.steps;
    if (!steps)
      return;
    steps.forEach((s2, i3) => {
      s2.index = i3;
      s2.setSize = steps.length;
      s2.linear = this.linear;
      s2.orientation = orientation;
      s2.labelMode = this.labelMode;
      s2.mode = this.mode;
      if (s2.spacer) {
        s2.spacer.orientation = orientation;
      }
    });
    this.visible = true;
    if (this.mode === "progress")
      return;
    this.handleSelectedStepChange(this.selectedStep, this.selectedStep);
    this.applyOrientationClass();
  }
  handleStepActivated(event) {
    if (this.linear && event.detail.index > this.selectedStep)
      return;
    this.gotoStep(event.detail.index);
  }
  handleStepActivationComplete(event) {
    const step = event.target;
    this.panels.forEach((panel) => panel.active = step.panel === panel.name);
  }
  handleKeyDown(event) {
    const orientation = getResponsiveValue(this.orientation, orientationTypes, "horizontal");
    const target = event.target;
    const step = target.closest("fadv-step");
    const stepper = step == null ? void 0 : step.closest("fadv-stepper");
    if (stepper !== this) {
      return;
    }
    if (["Enter", " "].includes(event.key)) {
      if (step !== null && (!this.linear || step.index < this.selectedStep)) {
        this.selectedStep = step.index;
      }
      event.preventDefault();
    }
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) {
      const activeEl = document.activeElement;
      if (hasTag(activeEl, "fadv-step")) {
        let index = this.steps.indexOf(activeEl);
        if (event.key === "Home") {
          index = 0;
        } else if (event.key === "End") {
          index = this.steps.length - 1;
        } else if (orientation === "horizontal" && event.key === "ArrowLeft" || this.orientation === "vertical" && event.key === "ArrowUp") {
          index = Math.max(0, index - 1);
        } else if (orientation === "horizontal" && event.key === "ArrowRight" || orientation === "vertical" && event.key === "ArrowDown") {
          index = Math.min(this.steps.length - 1, index + 1);
        }
        const nextStep = this.steps[index];
        nextStep.focus({ preventScroll: true });
        if (orientation === "horizontal") {
          nextStep == null ? void 0 : nextStep.scrollIntoView({ behavior: "smooth" });
        }
        event.preventDefault();
      }
    }
  }
  getRoles() {
    if (this.mode === "progress")
      return "list";
    return "tablist";
  }
  gotoStep(index) {
    var _a;
    if (index < 0)
      return;
    if (index > ((_a = this.steps) == null ? void 0 : _a.length) - 1)
      return;
    this.selectedStep = index;
  }
  nextStep() {
    this.gotoStep(this.selectedStep + 1);
  }
  previousStep() {
    this.gotoStep(this.selectedStep - 1);
  }
  handleResize() {
    this.syncSteps();
    this.hasScrollControls = getResponsiveValue(this.orientation, orientationTypes) !== "vertical" && this.stepContainer.scrollWidth > this.stepContainer.clientWidth;
  }
  handleScrollToStart() {
    this.stepContainer.scroll({
      left: this.stepContainer.scrollLeft - this.stepContainer.clientWidth,
      behavior: "smooth"
    });
  }
  handleScrollToEnd() {
    this.stepContainer.scroll({
      left: this.stepContainer.scrollLeft + this.stepContainer.clientWidth,
      behavior: "smooth"
    });
  }
  applyOrientationClass() {
    var _a;
    const stepper = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(".stepper");
    const orientation = getResponsiveValue(this.orientation, orientationTypes);
    stepper.classList.toggle("stepper--vertical", orientation === "vertical");
    stepper.classList.toggle("stepper--horizontal", orientation !== "vertical");
  }
  renderScrollStart() {
    if (!this.hasScrollControls)
      return w;
    return $`<sl-icon-button class="stepper__scroll-button stepper__scroll-button--start" name="chevron-left" library="solid" label=${t2("components:common.scrollToStart")} @click=${this.handleScrollToStart} ></sl-icon-button>`;
  }
  renderScrollEnd() {
    if (!this.hasScrollControls)
      return w;
    return $`<sl-icon-button class="stepper__scroll-button stepper__scroll-button--end" name="chevron-right" library="solid" label=${t2("components:common.scrollToEnd")} @click=${this.handleScrollToEnd} ></sl-icon-button>`;
  }
  render() {
    return $`<div class=${o({
      stepper: true,
      "stepper--has-panels": this.hasSlots.test("panel"),
      "stepper--has-scroll-controls": this.hasScrollControls
    })} style=${i2({
      visibility: this.visible ? "visible" : "hidden"
    })} @keydown=${this.handleKeyDown} @step-activated=${this.handleStepActivated} @step-activation-complete=${this.handleStepActivationComplete} ><div class="stepper__scroller">${this.renderScrollStart()}<div class="stepper__steps" role=${this.getRoles()}><slot @slotchange=${this.syncSteps}></slot></div>${this.renderScrollEnd()}</div><div class="stepper__panels"><slot name="panel"></slot></div></div>`;
  }
};
FadvStepper.styles = stepper_styles_default;
__decorateClass([
  e()
], FadvStepper.prototype, "selectedStep", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvStepper.prototype, "linear", 2);
__decorateClass([
  e({ converter: OrientationPropertyConverter })
], FadvStepper.prototype, "orientation", 2);
__decorateClass([
  e({ attribute: "label-mode" })
], FadvStepper.prototype, "labelMode", 2);
__decorateClass([
  e()
], FadvStepper.prototype, "mode", 2);
__decorateClass([
  t()
], FadvStepper.prototype, "visible", 2);
__decorateClass([
  t()
], FadvStepper.prototype, "hasScrollControls", 2);
__decorateClass([
  i(".stepper__steps")
], FadvStepper.prototype, "stepContainer", 2);
__decorateClass([
  watch("selectedStep", { waitUntilFirstUpdate: true })
], FadvStepper.prototype, "handleSelectedStepChange", 1);
__decorateClass([
  watch("orientation"),
  watch("linear"),
  watch("mode")
], FadvStepper.prototype, "syncSteps", 1);
FadvStepper = __decorateClass([
  n("fadv-stepper")
], FadvStepper);

export {
  FadvStepper
};
